/**
 * Plage qu'une prévisualisation de modèle va calculer, telle qu'on l'annonce
 * avant de lancer. Miroir de `generationDayOffsets`
 * (`backend/src/lib/generation-range.ts`) : la date choisie ouvre la plage,
 * « Ce jour » s'y arrête, « Semaine » va jusqu'au dimanche de cette semaine.
 */
export type GenerationScope = 'DAY' | 'WEEK'

function parseCivil(value: string): Date {
  const [year, month, day] = value.slice(0, 10).split('-').map(Number)
  return new Date(year, month - 1, day, 12)
}

function toCivil(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function generationRange(startDate: string, scope: GenerationScope): { start: string; end: string; dayCount: number } {
  const start = parseCivil(startDate)
  // 0 = lundi … 6 = dimanche.
  const dayOffset = (start.getDay() + 6) % 7
  const dayCount = scope === 'WEEK' ? 7 - dayOffset : 1
  const end = new Date(start)
  end.setDate(end.getDate() + dayCount - 1)
  return { start: toCivil(start), end: toCivil(end), dayCount }
}

function shortLabel(value: string): string {
  return parseCivil(value).toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' })
}

/** « Du mar. 06/10 au dim. 11/10 », ou « Le mar. 06/10 » pour un seul jour. */
export function generationRangeLabel(startDate: string, scope: GenerationScope): string {
  const range = generationRange(startDate, scope)
  return range.dayCount === 1
    ? `Le ${shortLabel(range.start)}`
    : `Du ${shortLabel(range.start)} au ${shortLabel(range.end)}`
}
